import {
  AllInventoryItemsState,
  AwaitingStoreOrderProposalsState,
  FilteredStoresState,
  REMOVE_STORE_ORDERS,
  REQUEST_ALL_STORE_INVENTORY_ITEMS,
  REQUEST_AWAITING_STORE_ORDER_PROPOSALS,
  REQUEST_FILTERED_STORES,
  REQUEST_FILTERED_STORES_DONE,
  REQUEST_STORE_DISTRIBUTORS,
  REQUEST_STORE_DISTRIBUTORS_DONE,
  REQUEST_STORE_INVENTORY_ITEMS,
  REQUEST_STORE_INVENTORY_ITEMS_DONE,
  REQUEST_STORE_ORDERS,
  REQUEST_STORE_ORDERS_DONE,
  REQUEST_STORES,
  REQUEST_STORES_DONE,
  SAVE_FILTERED_STORES,
  SAVE_FILTERED_STORES_DONE,
  StoreActionTypes,
  StoreDistributorsState,
  StoreInventoryItemsState,
  StoreOrdersState,
  StoresState
} from "./types";

const initialStoresState: StoresState = {
  isLoading: false,
  stores: []
};

const initialStoreInventoryItemsState: StoreInventoryItemsState = {
  isLoading: true,
  storeInventoryItems: []
};

const initialAllInventoryItemsState: AllInventoryItemsState = {
  isLoading: true,
  storeInventoryItems: []
};

const initialStoreDistributorsState: StoreDistributorsState = {
  isLoading: true,
  storeDistributors: []
};

const initialAwaitingStoreOrderProposalsState: AwaitingStoreOrderProposalsState =
  {
    awaitingStoreOrderProposals: []
  };

const initialStoreOrdersState: StoreOrdersState = {
  isLoading: true,
  orders: []
};

export function storesReducer(
  state = initialStoresState,
  action: StoreActionTypes
) {
  switch (action.type) {
    case REQUEST_STORES:
      return {
        isLoading: true,
        stores: action.payload
      };
    case REQUEST_STORES_DONE:
      return {
        isLoading: false,
        stores: action.payload
      };
    default:
      return state;
  }
}

export function storeInventoryItemsReducer(
  state = initialStoreInventoryItemsState,
  action: StoreActionTypes
) {
  switch (action.type) {
    case REQUEST_STORE_INVENTORY_ITEMS:
      return { isLoading: true, storeInventoryItems: action.payload };
    case REQUEST_STORE_INVENTORY_ITEMS_DONE:
      return { isLoading: false, storeInventoryItems: action.payload };
    default:
      return state;
  }
}

export function allStoreInventoryItemsReducer(
  state = initialAllInventoryItemsState,
  action: StoreActionTypes
) {
  switch (action.type) {
    case REQUEST_ALL_STORE_INVENTORY_ITEMS:
      return { isLoading: false, storeInventoryItems: action.payload };
    default:
      return state;
  }
}

export function storeDistributorsReducer(
  state = initialStoreDistributorsState,
  action: StoreActionTypes
) {
  switch (action.type) {
    case REQUEST_STORE_DISTRIBUTORS:
      return { isLoading: true, storeDistributors: action.payload };
    case REQUEST_STORE_DISTRIBUTORS_DONE:
      return { isLoading: false, storeDistributors: action.payload };
    default:
      return state;
  }
}

export function awaitingStoreOrderProposalsReducer(
  state = initialAwaitingStoreOrderProposalsState,
  action: StoreActionTypes
) {
  switch (action.type) {
    case REQUEST_AWAITING_STORE_ORDER_PROPOSALS:
      return action.payload;
    default:
      return state;
  }
}

export function storeOrdersReducer(
  state = initialStoreOrdersState,
  action: StoreActionTypes
) {
  switch (action.type) {
    case REQUEST_STORE_ORDERS:
      return {
        isLoading: true,
        orders: action.payload
      };
    case REQUEST_STORE_ORDERS_DONE:
      return {
        isLoading: false,
        orders: action.payload
      };
    case REMOVE_STORE_ORDERS:
      return {
        orders: state.orders.filter(
          so => !action.payload.some((o: any) => o.id === so.id)
        )
      };
    default:
      return state;
  }
}

const initialFilteredStoresState: FilteredStoresState = {
  isLoading: true,
  stores: []
};

export function filteredStoresReducer(
  state = initialFilteredStoresState,
  action: StoreActionTypes
) {
  switch (action.type) {
    case REQUEST_FILTERED_STORES:
      return {
        isLoading: true,
        stores: action.payload
      };
    case REQUEST_FILTERED_STORES_DONE:
      return {
        isLoading: false,
        stores: action.payload
      };
    case SAVE_FILTERED_STORES:
      return {
        isLoading: true,
        stores: action.payload
      };
    case SAVE_FILTERED_STORES_DONE:
      return {
        isLoading: false,
        stores: action.payload
      };
    default:
      return state;
  }
}
